import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { minorConsentSteps } from "@/mocks/legalPages";

/**
 * ご来院までの流れ（4 STEP）。
 * 既存SBDCのFLOWデザイン（罫線グリッド）を流用し、
 * PC 4列 / スマホ 縦方向で表示する。
 */
export default function VisitFlow() {
  return (
    <section className="bg-background-50 py-20 md:py-28 lg:py-32">
      <div className="u-container">
        <Reveal>
          <SectionHeading en="FLOW" jp="ご来院までの流れ" />
        </Reveal>

        <Reveal delay={120}>
          <ol className="mt-12 grid grid-cols-1 gap-px overflow-hidden border border-foreground-950/12 bg-foreground-950/12 sm:grid-cols-2 md:mt-16 lg:grid-cols-4">
            {minorConsentSteps.map((step) => (
              <li key={step.no} className="flex flex-col bg-background-50 p-7 md:p-8">
                <span className="font-label text-[12px] tracking-[0.25em] text-secondary-600">
                  {step.no}
                </span>
                <h3 className="mt-7 font-heading text-[16px] leading-[1.7] text-foreground-950 md:text-[17px]">
                  {step.title}
                </h3>
                <p className="mt-4 text-[13px] leading-[2] text-foreground-700 md:text-sm">
                  {step.text}
                </p>
              </li>
            ))}
          </ol>
        </Reveal>
      </div>
    </section>
  );
}